import { EditorCheckbox } from './EditorCheckbox';

export default EditorCheckbox;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/shared/EditorCheckbox/index.js